import { createContext, useContext } from "react";

const CustomContext = createContext();

export const useCustomContext = () => {
  return useContext(CustomContext);
};
export default CustomContext;
